module.exports = __webpack_public_path__ + "static/media/melissa12.1d45128a.jpg";